(function(module) {
  'use strict';
  module
    .controller('customerAccountController', ['$scope', 'progressBar', 'clientSelectService', 'agencySelectService',
      'customerAccount', 'ngDialog', 'uiGridConstants', 'commonDialog', 'commonDialogMessage', '$state',
      '$stateParams', 'toastFactory', 'authService',
      function($scope, progressBar, clientSelectService, agencySelectService, customerAccount, ngDialog,
        uiGridConstants, commonDialog, commonDialogMessage, $state, $stateParams, toastFactory, authService) {
        const progress = progressBar.getProgressBar();
        let id = $stateParams.id;
        if (!!id) {
          getCustomerAccoutsById(id);
          $scope.isEdit = true;
        };

        function getCustomerAccoutsById(id) {
          progress.start();
          customerAccount.getCustomerAccoutsById(id).then(function (customerAccount) {
            $scope.isEdit = true;
            $scope.customerAccount = customerAccount.data;
          }, function (err) {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function ($scope) {
                $scope.errMsg = `<p>${err.statusText}</p>`;
                $scope.errTitle = 'Get Customer Account Error';
              },],
            });
          })
            .finally(function () {
              progress.complete();
            });
        };
        // Begin ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        // ui-grid options
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: true,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          visible: true,
          enableColumnResizing: true,
          columnDefs: [{
            name: 'Name',
            displayName: 'Name',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Number',
            displayName: 'Number',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'IsDefaultAccount',
            visible: true,
            displayName: 'Default Account',
            enableSorting: true,
            enableFiltering: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableColumnResizing: true,
            maxWidth: 450,
          }, ],
          onRegisterApi: function(gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              setGridData();
            });
            // Show organization details on grid row selection.
            gridApi.selection.on.rowSelectionChanged($scope, function(row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
          },
        };
        $scope.edit = function() {
          $state.go('app.editCustomerAccoNum', {
            id: $scope.rowSelectingId,
          });
        };
        $scope.saveCustomerAccount = function() {
          const organization = clientSelectService.getSelectedClient();
          progress.start();
          customerAccount.addCustomerAccount($scope.customerAccount, organization.id).then(function() {
              const dialogPost = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Add Customer Account Success';
                  $scope.successMsg = 'The Customer Account has been added succesfully.';
                },],
              });
              dialogPost.closePromise.then(function(data) {
                $state.go('app.customerAccountNumbers');
              });
            }, function(err) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Customer Account Error';
                },],
              });
            })
            .finally(function() {
              progress.complete();
            });
        };
        $scope.updateCustomerAccount = function(id) {
          progress.start();
          customerAccount.updateCustomerAccount($scope.customerAccount.Id, $scope.customerAccount, $scope.customerAccount
              .OrganizationId).then(function(organization) {
              const dialogPut = ngDialog.open({
                template: 'templates/partials/viewSuccessMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.strTitle = 'Update Customer Account Success';
                  $scope.successMsg = 'The Customer Account has been updated succesfully.';
                },],
              });
              dialogPut.closePromise.then(function(data) {
                $state.go('app.customerAccountNumbers');
              });
            }, function(err) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function ($scope) {
                  $scope.errMsg = `<p>${err.statusText}</p>`;
                  $scope.errTitle = 'Update Customer Account Error';
                },],
              });
            })
            .finally(function() {
              progress.complete();
            });
        };
        $scope.deleteCustomerAccount = function() {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function ($scope) {
              $scope.strTitle = 'Delete Customer Account?';
              $scope.strMsg = 'Do you really want to delete this Customer Account?';
            },],
          });
          confirm.closePromise.then(function(data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              customerAccount.deleteCustomerAccount($scope.rowSelectingId).then(function(response) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.strTitle = 'Customer Account Deleted Successfully';
                      $scope.successMsg = 'The Customer Account has been succesfully deleted.';
                    },],
                  });
                  dialog.closePromise.then(function(data) {});
                }, function(err) {
                  if (err.status != 401) {
                    const dialog = ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function ($scope) {
                        $scope.errMsg = `<p>${err.statusText}</p>`;
                        $scope.errTitle = 'Delete Customer Account Error';
                      },],
                    });
                    dialog.closePromise.then(function(data) {});
                  }
                })
                .finally(function() {
                  progress.complete();
                  setGridData();
                });
            }
          });
        };
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        function setGridData() {
          if (authService.getLoginMember().Role === 3) {
            progress.start();
            customerAccount.getCustomerAccouts().then(function(customerAccount) {
                const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
                $scope.gridOptions.data = customerAccount.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
                $scope.gridOptions.totalItems = customerAccount.data.length;
                if (!customerAccount.data.length) {
                  //\\toastFactory.toast_warn(commonDialogMessage.customerAccountNoResultMessage);
                }
              }, function(err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function ($scope) {
                      $scope.errMsg = `<p>${err.statusText}</p>`;
                      $scope.errTitle = 'Customer Account Error';
                    },],
                  });
                }
              })
              .finally(function() {
                progress.complete();
              });
          } else {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid && valid.clientValid) {
              progress.start();
              let organization = clientSelectService.getSelectedClient();
              let organizationId = ((!!organization.id) ? organization.id : 0);
              customerAccount.getCustomerAccountByOrgId(organizationId).then(function(customerAccount) {
                  const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
                  $scope.gridOptions.data = customerAccount.data.slice(firstRow, firstRow + paginationOptions.pageSize);;
                  $scope.gridOptions.totalItems = customerAccount.data.length;
                  if (!customerAccount.data.length) {
                    //\\toastFactory.toast_warn(commonDialogMessage.customerAccountNoResultMessage);
                  }
              }, function (err) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`;
                    $scope.errTitle = 'Customer Account Error';
                  },],
                });
              })
                .finally(function () {
                  progress.complete();
                });
            } else {
              if (valid.agencyValid === false) {
                //toastFactory.toast_info('Please select an agency and a client.');
              } else {
                //toastFactory.toast_info('Please select a client.');
              }
            }
          }
        };
        $scope.view = function(rowEntity) {
          const selectedRow = !!rowEntity ? rowEntity : $scope.gridApi.selection.getSelectedRows()[0];
          if (!!selectedRow) {
            $scope.acctName = selectedRow.Name;
            $scope.acctNumber = selectedRow.Number;
            $scope.isDefaultAccount = selectedRow.IsDefaultAccount;
            const view = ngDialog.open({
              template: 'templates/partials/viewCustomerAccoNum.html',
              className: 'ngdialog-theme-plain',
              scope: $scope,
            });
            view.closePromise.then(function(data) {
              $scope.viewData = {};
            });
          }
        };
        
        setGridData();
        // Watch clientSelectService for changes to getFilteredOrganization() output
        // expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function() {
          return clientSelectService.getSelectedClient();
        }, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.gridOptions.data = [];
            $scope.gridOptions.totalItems = 0;
            setGridData();
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/customerAccountController.js